
import { getWindowDimensions } from "../utils"

const {
    REACT_APP_API_URL
} = process.env
console.log(REACT_APP_API_URL)
export const initialState = {
    API_URL: REACT_APP_API_URL,
    windowDimensions: getWindowDimensions(),
    inProgress: false,
    notification: null
}

const reducer = (state, action) => {
    switch (action.type) {
        case "DIMENSIONS":
            return {
                ...state,
                windowDimensions: getWindowDimensions()
            }
        case "PROGRESS":
            return {
                ...state,
                inProgress: action?.status || false
            }
        case "NOTIFICATION":
            return {
                ...state,
                notification: action?.notification || null
            }
        default:
            return state;
    }
}

export default reducer;